<!-- Back Button -->
<button type="button" class="btn btn-rbv" (click)="openOrder()">
  Order Detail
</button>

<!-- Order Detail -->
<div *ngIf="showOrderDetail" (mouseover)="showDragHandle=true" (mouseout)="showDragHandle=false"
  class="order-container">
  <!-- Drag Picker -->
  <div id="drag-picker" [hidden]="!showDragHandle"></div>

  <!-- Order Detail -->
  <div class="order-detail-noselect order-detail-container" id="order-detail-drag">
    <!-- Close button -->
    <i class="fa fa-close close-div" (click)="hideOrderDetail()"></i>

    <!-- Header -->
    <h4 class="title mt-3">Business Valuation & Equipment Appraisal Order Form</h4>

    <!-- Order Form -->
    <div class="row">
      <div class="col-md-12">
        <form #orderForm="ngForm" name="orderForm" class="control-area" *ngIf="order">

          <!-- Business Valuation Type -->
          <div class="form-group mt-3">
            <label>Are you looking to order a<span class="required"> * </span> <span class="desc-small">(please choose one
                or both)</span></label>

            <div class="rbv_report_type_check_group">
              <!-- Business Valuation -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='checkbox'
                  [name]="'BV_TYPE_VALUE'" [id]="'BV_TYPE_VALUE'"
                  [disabled]="isViewMode" [(ngModel)]="order.ORDER_BV"
                  [required]="!order.ORDER_EA"/>
                <label class="checkbox-custom-label" [for]="'BV_TYPE_VALUE'">Business Valuation</label>
              </div>

              <!-- Equipment Appraisel -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='checkbox'
                  [name]="'EA_TYPE_VALUE'" [id]="'EA_TYPE_VALUE'"
                  [disabled]="isViewMode" [(ngModel)]="order.ORDER_EA"
                  [required]="!order.ORDER_BV"/>
                <label class="checkbox-custom-label" [for]="'EA_TYPE_VALUE'">Equipment Appraisal</label>
              </div>

              <!-- Request a quote for now -->
              <div class="check_item hidden-print" *ngIf="!isViewMode">
                <a href="https://quote.reliantvalue.com">I'd like to request a quote for now</a>
              </div>
            </div>
          </div>

          <!-- Report Type -->
          <div class="form-group mt-3" *ngIf="order.ORDER_BV">
            <label>Report Type:</label>

            <!-- Conclusion-->
            <div class="rv_check_group">
              <div class="checkbox-item mr-5">
                <input class="checkbox-custom" type='radio' [name]="'REPORT_TYPE_CONCLUSION'"
                  [id]="'REPORT_TYPE_CONCLUSION'" [value]="ValuationType.CONCLUSION"
                  [disabled]="isViewMode" [(ngModel)]="order.BV_TYPE" required/>
                <label class="checkbox-custom-label" [for]="'REPORT_TYPE_CONCLUSION'">Conclusion of Value
                  <i class="fa fa-info-circle ml-1"[title]="popUpConclusionValueTemplate"></i>
                  <span class="description">(compliant as an independent/third party valuation for SBA purposes)</span>
                </label>
              </div>

              <!-- Calculation-->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'REPORT_TYPE_CALCULATION'"
                  [id]="'REPORT_TYPE_CALCULATION'" [value]="ValuationType.CALCULATION"
                  [disabled]="isViewMode" [(ngModel)]="order.BV_TYPE" required/>
                <label class="checkbox-custom-label" [for]="'REPORT_TYPE_CALCULATION'">Calculation of Value
                  <i class="fa fa-info-circle ml-1" [title]="popUpCalculationValueTemplate"></i>
                  <span class="description">(compliant <u>only</u> for internal valuation (SBA) / planning
                    purposes)</span>
                </label>
              </div>

              <!-- IV-->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'REPORT_TYPE_IV'"
                  [id]="'REPORT_TYPE_IV'" [value]="ValuationType.IV"
                  [disabled]="isViewMode" [(ngModel)]="order.BV_TYPE" required/>
                <label class="checkbox-custom-label" [for]="'REPORT_TYPE_IV'">Internal Valuation
                  <span class="description">(for internal valuation)</span>
                </label>
              </div>
            </div>
          </div>

          <!-- Purpose of business valuation -->
          <div class="form-group mt-2" *ngIf="order.ORDER_BV && order.BV_TYPE">
            <!-- Label -->
            <label>Is the purpose of this business valuation for bank financing (SBA/Conventional Loan)?<span
                class="required"> *</span></label>

            <!-- Options -->
            <div class="rv_check_group">
              <!-- Yes -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'isPurposeQuestion_Yes'"
                  [id]="'isPurposeQuestion_Yes'" [value]="true"
                  [disabled]="isViewMode" [(ngModel)]="order.PURPOSE_FINANCING" required/>
                <label class="checkbox-custom-label" [for]="'isPurposeQuestion_Yes'">Yes</label>
              </div>

              <!-- No -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'isPurposeQuestion_No'"
                  [id]="'isPurposeQuestion_NO'" [value]="false"
                  [disabled]="isViewMode" [(ngModel)]="order.PURPOSE_FINANCING" required/>
                <label class="checkbox-custom-label" [for]="'isPurposeQuestion_NO'">No</label>
              </div>

              <!-- State purpose input -->
              <div class="input-purpose" *ngIf="order.PURPOSE_FINANCING != undefined && !order.PURPOSE_FINANCING">
                <input type="text" class="form-control rounded-0" name="PURPOSE_DESC"
                  [disabled]="isViewMode" [(ngModel)]="order.PURPOSE_DESC" required
                  placeholder="Please state the purpose of the valuation: (e.g. Help me determine the value of my business, Gift/Estate)" />
              </div>
            </div>
          </div>

          <!-- Rush Required -->
          <div class="form-group" *ngIf="order.PURPOSE_FINANCING">
            <!-- Label -->
            <label>Do you require a rush? <span class="desc-small">(standard turnaround time is 6-7 business days after
                order is processed and engagement letter signed)</span></label>

            <!-- Options -->
            <div class="rv_check_group">
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio'
                  [name]="'RUSH_REQUIRED_YES'" [id]="'RUSH_REQUIRED_YES'" required
                  [value]="true" [disabled]="isViewMode" [(ngModel)]="order.RUSH"/>
                <label class="checkbox-custom-label" [for]="'RUSH_REQUIRED_YES'">Yes</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio'
                  [name]="'RUSH_REQUIRED_NO'" [id]="'RUSH_REQUIRED_NO'" required
                  [value]="false" [disabled]="isViewMode" [(ngModel)]="order.RUSH"/>
                <label class="checkbox-custom-label" [for]="'RUSH_REQUIRED_NO'">No</label>
              </div>
            </div>
          </div>

          <!-- Rush speed -->
          <div class="form-group" *ngIf="order.PURPOSE_FINANCING && order.RUSH">
            <!-- Title -->
            <label>
              How fast? <span class="required">* </span> <span class="desc-small">(we will provide you with rush pricing in our order processing email)</span>
            </label>

            <!-- Options -->
            <div class="rv_check_group">
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'RUSH_SPEED_3'"
                  [id]="'RUSH_SPEED_3'" [value]="3" required
                  [disabled]="isViewMode" [(ngModel)]="order.RUSH_SPEED"/>
                <label class="checkbox-custom-label" [for]="'RUSH_SPEED_3'">3 business days</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'RUSH_SPEED_5'"
                  [id]="'RUSH_SPEED_5'" [value]="5" required
                  [disabled]="isViewMode" [(ngModel)]="order.RUSH_SPEED"/>
                <label class="checkbox-custom-label" [for]="'RUSH_SPEED_5'">5 business days</label>
              </div>
            </div>
          </div>

          <!-- Equipment Appraisal Report Type -->
          <div class="form-group" *ngIf="order.ORDER_EA">
            <!-- Title -->
            <label>Equipment Appraisal Report Type <span class="required">*</span></label>

            <!-- Options -->
            <div class="rv_check_group">
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'EV_REPORT_TYPE_DESKTOP'"
                  [id]="'EV_REPORT_TYPE_DESKTOP'" [value]="'DESKTOP'"
                  [disabled]="isViewMode" [(ngModel)]="order.EA_TYPE" required/>
                <label class="checkbox-custom-label" [for]="'EV_REPORT_TYPE_DESKTOP'">Desktop <i>(no site
                    visit)</i></label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'EV_REPORT_TYPE_SUMMARY'"
                  [id]="'EV_REPORT_TYPE_SUMMARY'" [value]="'SUMMARY'"
                  [disabled]="isViewMode" [(ngModel)]="order.EA_TYPE" required/>
                <label class="checkbox-custom-label" [for]="'EV_REPORT_TYPE_SUMMARY'">Summary <i>(with site
                    visit)</i></label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'EV_REPORT_TYPE_BOTH'"
                  [id]="'EV_REPORT_TYPE_BOTH'" [value]="'BOTH'" required
                  [disabled]="isViewMode" [(ngModel)]="order.EA_TYPE"/>
                <label class="checkbox-custom-label" [for]="'EV_REPORT_TYPE_BOTH'">Provide quotes for both Desktop and Summary </label>
              </div>
            </div>
          </div>

          <!-- Location description -->
          <div class="form-group" *ngIf="order.ORDER_EA">
            <label>Please list all locations where equipment is located <span class="required">*</span></label>
            <textarea class="form-control rounded-0" cols="3" placeholder="Equipment location(s)"
              name="eaEqLocations" style="min-height: 100px;" required
              [disabled]="isViewMode" [(ngModel)]="order.EA_LOCATIONS"></textarea>
          </div>

          <!-- Engagement Address -->
          <div class="form-group" *ngIf="order.ORDER_EA">
            <label>Address to be used in Engagement Letter</label>
            <textarea class="form-control rounded-0" cols="3" placeholder="Bank HQ, Main Office, etc."
              name="eaEngAddress" style="min-height: 100px;" required
              [disabled]="isViewMode" [(ngModel)]="order.EA_ENG_ADDRESS"></textarea>
          </div>

          <!-- Company name -->
          <div class="form-group">
            <label>Name of Company Being Valued
              <span class="required">*</span>
              <span style="font-weight: normal;">
                <i>(as it appears on tax returns)</i>
              </span>
              <span class="desc-small">(separate multiple entities with a comma)</span>
            </label>

            <!-- List of company names -->
            <div *ngFor="let name of order.COMPANY_NAME; let i = index; trackBy: trackByFn;"
              class="m-b-10 d-flex">
              <input type="text" required class="form-control rounded-0"
                placeholder="Company Name" name="COMPANY_NAME{{i}}" required
                [disabled]="isViewMode" [(ngModel)]="order.COMPANY_NAME[i]"/>

              <!-- Add Button -->
              <button type="button" *ngIf="i === 0" [disabled]="isViewMode || loading"
                class="btn btn-rbv ml-2" (click)="addCompanyName()" style="width: 92px;">
                <i class="fa fa-plus mr-1"></i>
                Add
              </button>

              <!-- Remove Button -->
              <button type="button" *ngIf="i !== 0" [disabled]="isViewMode || loading"
                class="btn btn-rbv ml-2" (click)="removeCompanyName(i)">
                <i class="fa fa-trash mr-1"></i>
                Remove
              </button>
            </div>
          </div>

          <!-- Company's Business -->
          <div class="form-group">
            <label class="control-label">Doing Business As (Trade Name)</label>
            <input type="text" class="form-control rounded-0" placeholder="FedEx, Subway, etc."
              name="tradeName" [disabled]="isViewMode" [(ngModel)]="order.COMPANY_DBA"/>
          </div>

          <!-- Company operates on multi-location? -->
          <div class="form-group">
            <!-- Title -->
            <label class="control-label">Does the Company operate from more than one location? <span
                class="required">*</span></label>

            <!-- Options -->
            <div class="rv_check_group">
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'COMPANY_MULTILOCATION_YES'"
                  [id]="'COMPANY_MULTILOCATION_YES'" [value]="true" [disabled]="isViewMode"
                  [(ngModel)]="order.MULTI_LOCATION" required/>
                <label class="checkbox-custom-label" [for]="'COMPANY_MULTILOCATION_YES'">Yes</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'COMPANY_MULTILOCATION_NO'"
                  [id]="'COMPANY_MULTILOCATION_NO'" [value]="false" [disabled]="isViewMode"
                  [(ngModel)]="order.MULTI_LOCATION" required/>
                <label class="checkbox-custom-label" [for]="'COMPANY_MULTILOCATION_NO'">No</label>
              </div>
            </div>
          </div>

          <!-- Multi location description -->
          <div class="form-group" *ngIf="order.MULTI_LOCATION">
            <label class="control-label">Please Describe <span class="required">*</span></label>
            <textarea class="form-control rounded-0" cols="3" placeholder="Please Describe"
              name="moreLoc" style="min-height: 150px;" required
              [disabled]="isViewMode" [(ngModel)]="order.MULTI_LOCATION_DESC"></textarea>
          </div>

          <!-- Person Submit -->
          <div class="form-group">
            <!-- Title -->
            <label class="control-label auto-width">Individual Submitting This Order <span
                class="required">*</span></label>

            <!-- Person Submit Contact options -->
            <div class="rv_check_group">
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PERSON_SUBMIT_CONTACT_LENDER'"
                  [id]="'PERSON_SUBMIT_CONTACT_LENDER'" [value]="'LENDER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PERSON_SUBMIT_CONTACT_LENDER'">Lender</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PERSON_SUBMIT_CONTACT_BUYER'"
                  [id]="'PERSON_SUBMIT_CONTACT_BUYER'" [value]="'BUYER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PERSON_SUBMIT_CONTACT_BUYER'">Buyer</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PERSON_SUBMIT_CONTACT_SELLER'"
                  [id]="'PERSON_SUBMIT_CONTACT_SELLER'" [value]="'SELLER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PERSON_SUBMIT_CONTACT_SELLER'">Seller</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PERSON_SUBMIT_CONTACT_OTHER'"
                  [id]="'PERSON_SUBMIT_CONTACT_OTHER'" [value]="'OTHER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PERSON_SUBMIT_CONTACT_OTHER'">Other</label>
              </div>

              <div class="other" *ngIf="order.PERSON_SUBMIT.CONTACT === 'OTHER'">
                <input type="text" class="form-control rounded-0" name="persOther"
                  placeholder="Individual's Relationship To Company" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.OTHER"/>
              </div>
            </div>
          </div>

          <!-- Person Submit Name -->
          <div class="form-row">
            <!-- First Name -->
            <div class="form-group col-md-6">
              <label class="control-label">First Name <span class="required">*</span></label>
              <input type="text" class="form-control rounded-0"
                placeholder="First Name" name="personSubmitFirstName" required
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.FIRST_NAME"/>
            </div>

            <!-- Last Name -->
            <div class="form-group col-md-6">
              <label class="control-label">Last Name <span class="required">*</span></label>
              <input type="text" class="form-control rounded-0"
                placeholder="Last Name" name="personSubmitLastName" required
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.LAST_NAME"/>
            </div>
          </div>

          <!-- Person Submit (Email + Phone + PhoneType) -->
          <div class="form-row">
            <!-- Email -->
            <div class="form-group col-md-6">
              <label class="control-label">Email <span class="required">*</span></label>
              <input type="text" class="form-control rounded-0"
                placeholder="Email" name="personSubmitEmail" required
                pattern="^[_aA-zZ0-9\-\_]+(\.[_aA-zZ0-9\-\_]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$"
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.EMAIL"/>
            </div>

            <!-- (Phone + PhoneType) -->
            <div class="form-group col-md-6">
              <!-- PhoneType -->
              <div class="wrapper-phone">
                <label class="control-label">Phone <span class="required">*</span></label>
                <div class="rv_check_group" *ngIf="order.PERSON_SUBMIT.CONTACT === 'BUYER' || order.PERSON_SUBMIT.CONTACT === 'SELLER'">
                  <div class="checkbox-item">
                    <input class="checkbox-custom" type='radio' [name]="'PERSON_SUBMIT_PHONE_PERSONAL'"
                      [id]="'PERSON_SUBMIT_PHONE_PERSONAL'" [value]="PhoneType.PERSONAL" required
                      [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.PHONE_TYPE"/>
                    <label class="checkbox-custom-label" [for]="'PERSON_SUBMIT_PHONE_PERSONAL'">Personal</label>
                  </div>

                  <div class="checkbox-item">
                    <input class="checkbox-custom" type='radio' [name]="'PERSON_SUBMIT_PHONE_BUSINESS'"
                      [id]="'PERSON_SUBMIT_PHONE_BUSINESS'" [value]="PhoneType.BUSINESS" required
                      [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.PHONE_TYPE"/>
                    <label class="checkbox-custom-label" [for]="'PERSON_SUBMIT_PHONE_BUSINESS'">Business</label>
                  </div>
                </div>
              </div>

              <!-- Phone Input -->
              <input type="text" class="form-control rounded-0" placeholder="Phone"
                name="PERSON_SUBMIT_PHONE" required
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_SUBMIT.PHONE"/>
            </div>
          </div>

          <!-- Company Submit -->
          <div class="form-group">
            <div class="no-space">
              <!-- Title -->
              <label class="control-label">Individual That Can Answer Questions About The Property  <span
                  class="required">*</span></label>

              <!-- Same as Person submit -->
              <div class="checkbox-item ml-3" *ngIf="!isViewMode">
                <input class="checkbox-custom" type='radio' [name]="'SameAsPersonSubmit'" [id]="'SameAsPersonSubmit'"
                  [value]="true" [disabled]="isViewMode" [(ngModel)]="sameAsIndividual"/>
                <label class="checkbox-custom-label" [for]="'SameAsPersonSubmit'">Individual Submitting Order</label>
              </div>
            </div>

            <!-- Company Submit Contact options -->
            <div class="rv_check_group">
              <!-- Lender -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PersonCompanyContactLender'"
                  [id]="'PersonCompanyContactLender'" [value]="'LENDER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PersonCompanyContactLender'">Lender</label>
              </div>

              <!-- Buyer -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PersonCompanyContactBuyer'"
                  [id]="'PersonCompanyContactBuyer'" [value]="'BUYER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PersonCompanyContactBuyer'">Buyer</label>
              </div>

              <!-- Seller -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PersonCompanyContactSeller'"
                  [id]="'PersonCompanyContactSeller'" [value]="'SELLER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PersonCompanyContactSeller'">Seller</label>
              </div>

              <!-- Other -->
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio' [name]="'PersonCompanyContactOther'"
                  [id]="'PersonCompanyContactOther'" [value]="'OTHER'" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.CONTACT"/>
                <label class="checkbox-custom-label" [for]="'PersonCompanyContactOther'">Other</label>
              </div>

              <!-- Relationship to company -->
              <div class="other" *ngIf="order.PERSON_COMPANY.CONTACT === 'OTHER'">
                <input type="text" class="form-control rounded-0" required
                  name="PERSON_COMPANY_OTHER" placeholder="Individual's Relationship To Company"
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.OTHER"/>
              </div>
            </div>
          </div>

          <!-- Company submit Name -->
          <div class="form-row">
            <!-- First Name -->
            <div class="form-group col-md-6">
              <label class="control-label">Name <span class="required">*</span></label>
              <input type="text" class="form-control rounded-0" placeholder="Name"
                name="PERSON_COMPANY_FIRST_NAME" required
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.FIRST_NAME"/>
            </div>

            <!-- Last Name -->
            <div class="form-group col-md-6">
              <label class="control-label">Name <span class="required">*</span></label>
              <input type="text" class="form-control rounded-0"
                placeholder="Name" name="PERSON_COMPANY_LAST_NAME" required
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.LAST_NAME"/>
            </div>
          </div>

          <!-- Company submit (Email + Phone + PhoneType) -->
          <div class="form-row">
            <!-- Email -->
            <div class="form-group col-md-6">
              <label class="control-label">Email <span class="required">*</span></label>
              <input type="text" class="form-control rounded-0"
                placeholder="Email address" name="PERSON_COMPANY_EMAIL" required
                pattern="^[_aA-zZ0-9\-\_]+(\.[_aA-zZ0-9\-\_]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$"
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.EMAIL"/>
            </div>

            <!-- Phone + Phonetype -->
            <div class="form-group col-md-6">
              <div class="wrapper-phone">
                <label class="control-label">Phone <span class="required">*</span></label>
                <div class="rv_check_group" *ngIf="order.PERSON_COMPANY.CONTACT === 'BUYER' || order.PERSON_COMPANY.CONTACT === 'SELLER'">
                  <div class="checkbox-item">
                    <input class="checkbox-custom" type='radio' [name]="'PERSON_COMPANY_PHONE_TYPE_PERSONAL'"
                      [id]="'PersonSubmitPhonePersonal'" [value]="PhoneType.PERSONAL" required
                      [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.PHONE_TYPE"/>
                    <label class="checkbox-custom-label" [for]="'PersonSubmitPhonePersonal'">Personal</label>
                  </div>

                  <div class="checkbox-item">
                    <input class="checkbox-custom" type='radio' [name]="'PERSON_COMPANY_PHONE_TYPE_BUSINESS'"
                      [id]="'PersonSubmitPhoneBusiness'" [value]="PhoneType.BUSINESS" required
                      [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.PHONE_TYPE"/>
                    <label class="checkbox-custom-label" [for]="'PersonSubmitPhoneBusiness'">Business</label>
                  </div>
                </div>
              </div>

              <!-- Phone input -->
              <input type="text" class="form-control rounded-0"
                placeholder="Phone" name="PERSON_COMPANY_PHONE" required
                [disabled]="isViewMode" [(ngModel)]="order.PERSON_COMPANY.PHONE"/>
            </div>
          </div>

          <!-- Seller's permission -->
          <div class="form-group"
            *ngIf="order.PERSON_SUBMIT.CONTACT && order.PERSON_COMPANY.CONTACT && order.PERSON_SUBMIT.CONTACT != 'SELLER' && order.PERSON_COMPANY.CONTACT != 'SELLER'">
            <!-- Title -->
            <label class="control-label">If we have questions, are we authorized to contact the owner of the Company
              (Seller)? <span class="required">*</span></label>

            <!-- Options -->
            <div class="rv_check_group">
              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio'
                  [name]="'SELLER_PERMISSION_YES'" [id]="'SellerPermissionYes'" required
                  [value]="true" [disabled]="isViewMode" [(ngModel)]="order.SELLER_PERMISSION"/>
                <label class="checkbox-custom-label" [for]="'SellerPermissionYes'">Yes</label>
              </div>

              <div class="checkbox-item">
                <input class="checkbox-custom" type='radio'
                  [name]="'SELLER_PERMISSION_NO'" [id]="'SellerPermissionNo'" required
                  [value]="false" [disabled]="isViewMode" [(ngModel)]="order.SELLER_PERMISSION"/>
                <label class="checkbox-custom-label" [for]="'SellerPermissionNo'">No</label>
              </div>

              <div class="checkbox-item" *ngIf="order.SELLER_PERMISSION != undefined && !order.SELLER_PERMISSION">
                <input class="checkbox-custom" type='radio' [name]="'SELLER_CAN_CONTACT'"
                  [id]="'SellerPermissionCanContact'" [value]="true"
                  [disabled]="isViewMode" [(ngModel)]="order.SELLER_CAN_CONTACT"/>
                <label class="checkbox-custom-label" [for]="'SellerPermissionCanContact'">
                  You may contact the Seller only if the Buyer provides you with permission via email.
                </label>
              </div>
            </div>
          </div>

          <!-- PERSON_SELLER CONTACT -->
          <div *ngIf="order.PERSON_SUBMIT.CONTACT && order.PERSON_COMPANY.CONTACT && order.PERSON_SUBMIT.CONTACT != 'SELLER' && order.PERSON_COMPANY.CONTACT != 'SELLER' && order.SELLER_PERMISSION">
            <!-- Seller's Contact -->
            <div class="form-group">
              <div class="no-space">
                <label class="control-label">Seller's Contact Information</label>
                <div class="checkbox-item ml-3">
                  <input class="checkbox-custom" type='radio'
                    [name]="'SELLER_NOT_AVAILABLE'" [id]="'SellerUnavailable'"
                    [value]="true" [disabled]="isViewMode"
                    [(ngModel)]="order.SELLER_NOT_AVAILABLE"/>
                  <label class="checkbox-custom-label" [for]="'SellerUnavailable'">Unavailable At This Time</label>
                </div>
              </div>
            </div>

            <!-- Seller's Name -->
            <div class="form-row">
              <!-- First Name -->
              <div class="form-group col-md-6">
                <label class="control-label">First Name <span class="required">*</span></label>
                <input type="text" class="form-control rounded-0"
                  placeholder="First Name" name="PERSON_SELLER_FIRST_NAME" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SELLER.FIRST_NAME"/>
              </div>

              <!-- Last Name -->
              <div class="form-group col-md-6">
                <label class="control-label">Last Name <span class="required">*</span></label>
                <input type="text" class="form-control rounded-0"
                  placeholder="Last Name" name="PERSON_SELLER_LAST_NAME" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SELLER.LAST_NAME"/>
              </div>
            </div>

            <!-- Seller submit (Email + Phone + PhoneType) -->
            <div class="form-row">
              <!-- Seller's Email -->
              <div class="form-group col-md-6">
                <label class="control-label">Email <span class="required">*</span></label>
                <input type="text" class="form-control rounded-0"
                  placeholder="Email address" name="PERSON_SELLER_EMAIL" required
                  pattern="^[_aA-zZ0-9\-\_]+(\.[_aA-zZ0-9\-\_]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$"
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SELLER.EMAIL"/>
              </div>

              <!-- Seller's Phone -->
              <div class="form-group col-md-6">
                <div class="wrapper-phone">
                  <label class="control-label">Phone <span class="required">*</span></label>
                  <div class="rv_check_group">
                    <div class="checkbox-item">
                      <input class="checkbox-custom" type='radio' [name]="'PERSON_SELLER_PHONE_TYPE_PERSONAL'"
                        [id]="'SellerConactPersonal'" [value]="'PERSONAL'" required
                        [disabled]="isViewMode" [(ngModel)]="order.PERSON_SELLER.PHONE_TYPE"/>
                      <label class="checkbox-custom-label" [for]="'SellerConactPersonal'">Personal</label>
                    </div>

                    <div class="checkbox-item">
                      <input class="checkbox-custom" type='radio' [name]="'PERSON_SELLER_PHONE_TYPE_BUSINESS'"
                        [id]="'SellerConactBusiness'" [value]="'BUSINESS'" required
                        [disabled]="isViewMode" [(ngModel)]="order.PERSON_SELLER.PHONE_TYPE"/>
                      <label class="checkbox-custom-label" [for]="'SellerConactBusiness'">Business</label>
                    </div>
                  </div>
                </div>

                <!-- Seller's phone input -->
                <input type="text" class="form-control rounded-0"
                  placeholder="Phone" name="PERSON_SELLER_PHONE" required
                  [disabled]="isViewMode" [(ngModel)]="order.PERSON_SELLER.PHONE"/>
              </div>
            </div>
          </div>

          <!-- PERSON_LENDER CONTACT -->
          <div *ngIf="order.PURPOSE_FINANCING && order.PERSON_SUBMIT.CONTACT && order.PERSON_COMPANY.CONTACT && order.PERSON_SUBMIT.CONTACT != 'LENDER' && order.PERSON_COMPANY.CONTACT != 'LENDER'">
            <div class="form-group">
              <!-- title -->
              <div class="no-space">
                <label class="control-label">Lender Contact <span class="required">*</span></label>
                <span class="desc-small hidden-print" style="margin-left: 10px;line-height: 21px;">
                  (Individual at the bank to whom questions should be forwarded regarding the company)
                </span>
              </div>

              <!-- Lender contact options -->
              <div class="rv_check_group">
                <div class="checkbox-item">
                  <input class="checkbox-custom" type='radio'
                    [name]="'PERSON_LENDER_CONTACT_CLOSER'" [id]="'lenderContactCloser'"
                    [value]="'CLOSER'" [disabled]="isViewMode" required
                    [(ngModel)]="order.PERSON_LENDER.CONTACT"/>
                  <label class="checkbox-custom-label" [for]="'lenderContactCloser'">Closer</label>
                </div>

                <div class="checkbox-item">
                  <input class="checkbox-custom" type='radio'
                    [name]="'PERSON_LENDER_CONTACT_UNDERWRITER'" [id]="'lenderContactUnderwriter'"
                    [value]="'UNDERWRITER'" [disabled]="isViewMode" required
                    [(ngModel)]="order.PERSON_LENDER.CONTACT"/>
                  <label class="checkbox-custom-label" [for]="'lenderContactUnderwriter'">Underwriter</label>
                </div>

                <div class="checkbox-item">
                  <input class="checkbox-custom" type='radio'
                    [name]="'PERSON_LENDER_CONTACT_BDO'" [id]="'lenderContactBDO'"
                    [value]="'BDO'" [disabled]="isViewMode" required
                    [(ngModel)]="order.PERSON_LENDER.CONTACT"/>
                  <label class="checkbox-custom-label" [for]="'lenderContactBDO'">BDO</label>
                </div>

                <div class="checkbox-item">
                  <input class="checkbox-custom" type='radio'
                    [name]="'PERSON_LENDER_CONTACT_OTHER'" [id]="'lenderContactOther'"
                    [value]="'OTHER'" [disabled]="isViewMode" required
                    [(ngModel)]="order.PERSON_LENDER.CONTACT"/>
                  <label class="checkbox-custom-label" [for]="'lenderContactOther'">Other</label>
                </div>

                <!-- Other -->
                <div class="other" *ngIf="order.PERSON_LENDER.CONTACT === 'OTHER'">
                  <input type="text" class="form-control rounded-0" required
                    name="PERSON_LENDER_OTHER" placeholder="Other Lender Contact"
                    [disabled]="isViewMode" [(ngModel)]="order.PERSON_LENDER.OTHER"/>
                </div>
              </div>

              <!-- Lender's Name -->
              <div class="form-row">
                <!-- First Name -->
                <div class="form-group col-md-6">
                  <label class="control-label">First Name <span class="required">*</span></label>
                  <input type="text" class="form-control rounded-0"
                    placeholder="First Name" name="PERSON_LENDER_FIRST_NAME" required
                    [disabled]="isViewMode" [(ngModel)]="order.PERSON_LENDER.FIRST_NAME"/>
                </div>

                <!-- Last Name -->
                <div class="form-group col-md-6">
                  <label class="control-label">Last Name <span class="required">*</span></label>
                  <input type="text" class="form-control rounded-0"
                    placeholder="Last Name" name="PERSON_LENDER_LAST_NAME" required
                    [disabled]="isViewMode" [(ngModel)]="order.PERSON_LENDER.LAST_NAME"/>
                </div>
              </div>

              <!-- Lender submit (Email + Phone + PhoneType) -->
              <div class="form-row">
                <!-- Lender's Email -->
                <div class="form-group col-md-6">
                  <label class="control-label">Email <span class="required">*</span></label>
                  <input type="text" class="form-control rounded-0"
                    placeholder="Email address" name="PERSON_LENDER_EMAIL" required
                    pattern="^[_aA-zZ0-9\-\_]+(\.[_aA-zZ0-9\-\_]+)*@[aA-zZ0-9-\-\_\.]+\.([aA-zZ]{2,15})$"
                    [disabled]="isViewMode" [(ngModel)]="order.PERSON_LENDER.EMAIL"/>
                </div>

                <!-- Lender's Phone -->
                <div class="form-group col-md-6">
                  <div class="wrapper-phone">
                    <label class="control-label">Phone <span class="required">*</span></label>
                  </div>

                  <!-- Lender's phone input -->
                  <input type="text" class="form-control rounded-0"
                    placeholder="Phone" name="PERSON_LENDER_PHONE"required
                    [disabled]="isViewMode" [(ngModel)]="order.PERSON_LENDER.PHONE"/>
                </div>
              </div>
            </div>
          </div>

          <!-- Comments -->
          <div class="form-group">
            <label class="control-label">Additional Comments</label>
            <textarea class="form-control rounded-0" cols="4" maxlength="750" name="ORDER_COMMENTS"
              [(ngModel)]="order.COMMENTS"
              placeholder="For Example: Please contact Lender first before any other contact. &#10;If additional space is needed, please email order@reliantvalue.com"
              style="min-height: 100px;" [disabled]="isViewMode"></textarea>
          </div>

          <!-- Easy to use? -->
          <div class="eval-form">
            <!-- Like + Unlike -->
            <div class="value">
              <div class="thumbs up">
                <i class="fa fa-thumbs-o-up"></i>
              </div>
              <div class="thumbs down">
                <i class="fa fa-thumbs-o-down"></i>
              </div>
            </div>

            <!-- Title -->
            <label class="control-label" style="margin-right: 10px;margin-bottom: 0;">
              This order form was easy to use.
            </label>

            <!-- Sugesstion -->
            <div class="suggestion">
              <input type="text" class="form-control rounded-0" placeholder="How can we make this form easier to use?"
                name="suggestions" maxlength="150" [disabled]="isViewMode" [(ngModel)]="order.SUGGESTIONS"/>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- login page -->
<div *ngIf="displayLoginScreen" (mouseover)="showDragHandle=true" (mouseout)="showDragHandle=false"
  class="order-container">
  <!-- Drag Picker -->
  <div id="drag-picker" [hidden]="!showDragHandle"></div>

  <div class="order-detail-noselect" id="order-login">
    <section class="login-section">
      <div class="container h-100">
        <!-- Close button -->
        <i class="fa fa-close close-div" style="right: 5px; top: 2px;" (click)="closeLoginScreen()"></i>

        <div class="row align-items-center h-100 justify-content-center">
          <div class="card rounded-0 card-login border-0">
            <div class="text-center mb-3">
              <img src="assets/images/header-logo.png" />
            </div>

            <div class="card-body">
              <lib-crm-alert #alert></lib-crm-alert>
              <form *ngIf="!tfaFlag" [formGroup]="loginForm" name="form" class="loginForm" (ngSubmit)="onLoginSubmit()">
                <div class="form-group row">
                  <label for="inputEmail" class="col-sm-3 col-form-label">Email</label>
                  <div class="col-sm-8">
                    <input type="email" formControlName="USER_EMAIL" name="USER_EMAIL" id="inputEmail"
                      class="form-control rounded-0" placeholder="Your email" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="inputPassword" class="col-sm-3 col-form-label">Password</label>
                  <div class="col-sm-8">
                    <input type="password" formControlName="USER_PASSWORD" id="inputPassword" name="USER_PASSWORD"
                      class="form-control rounded-0" placeholder="Password" required />

                    <!-- <div class="text-right">
                      <a href="#" routerLink="/forgot" class="text-muted">Forgot your password?</a>
                    </div> -->
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 mx-auto">
                    <button [disabled]="!loginForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0"
                      (click)="onLoginSubmit()">
                      Sign In
                    </button>
                  </div>
                </div>
              </form>

              <form *ngIf="tfaFlag" [formGroup]="authForm" name="form" class="authForm" (ngSubmit)="onAuthSubmit()">

                <div class="row">
                  <div class="col-6 mx-auto">
                    <div class="form-group">
                      <input type="email" formControlName="AUTH_CODE" name="AUTH_CODE" id="inputCode"
                        class="form-control rounded-0" placeholder="Your auth code" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6 mx-auto">
                    <button [disabled]="!authForm.valid" type="submit" class="btn btn-login btn-lg btn-block rounded-0">
                      <!-- <fa-icon *ngIf="loading" icon="spinner" spin="true"></fa-icon> --> Submit
                    </button>
                  </div>
                </div>

              </form>
            </div>

          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Conclusion hover text -->
<ng-template #popUpConclusionValueTemplate>
  <div>
    As per <i>SOP 50 10 5(K)</i> p.203: If the amount being financed (including any 7(a), 504, seller, or other
    financing) minus the
    appraised value of real estate and/or equipment being financed is greater than $250,000 or if there is a
    close
    relationship
    between the buyer and seller (for example, transactions between existing owners or family members), the
    <b>Lender
      must obtain an
      independent business valuation from a qualified source</b>.<br /><br />
    This report is:<br />
    <ul style="padding-left: 30px;margin-bottom: 0;">
      <li>Compliant with SBA SOP requirements (latest version) as an â€œindependent business valuation from a
        qualified
        source</li>
      <li>Compiled by a CBA or CVA (â€˜qualified source as per the SOP)</li>
      <li>Uniform Standards of Professional Appraisal Practice (USPAP) Compliant</li>
      <li>Completed in accordance with The Institute of Business Appraisers and the National Association of
        Certified Valuators and Analysts' Professional Standards</li>
      <li>Typically 90-100 pages with all add-back proof appended to report</li>
      <li>Income, Market and Asset Approach analyzed (as applicable)</li>
    </ul>
  </div>
</ng-template>

<!-- Calculation hover text -->
<ng-template #popUpCalculationValueTemplate>
  <div>
    As per <i>SOP 50 10 5(K)</i> p.203: If the amount being financed (including any 7(a), 504, seller, or other
    financing) minus the
    appraised value of real estate and/or equipment being financed is $250,000 or less, the <b>Lender may
      perform its
      own valuation</b> of the business being sold.<br /><br />
    This report is:<br />
    <ul style="padding-left: 30px;margin-bottom: 0;">
      <li>Used for Internal Valuation purposes</li>
      <li>NOT USPAP compliant</li>
      <li>Typically 40 pages with no add-back proof analyzed</li>
      <li>Market and Asset Approach Methods analyzed, no Income Approach</li>
    </ul>
  </div>
</ng-template>
